import TheGrid from '@/views/campaigns/bestof/campaigns/grid'
import Edit from '@/views/campaigns/bestof/campaigns/edit'

export default {
  path: '/campaigns/bestof/campaigns',
  redirect: '/campaigns/bestof/campaigns/index',
  name: 'bestof',
  meta: {
    auth: {
      redirect: {
        name: 'bestof.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'bestof.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'bestof.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
